import { isPdfUrl } from 'src/utils/isPdfUrl';

export type TExternalLinkProps = {
    target?: '_blank';
    rel?: 'noopener noreferrer';
};

const secureNewTabProps: TExternalLinkProps = {
    target: '_blank',
    rel: 'noopener noreferrer'
};

export const getExternalLinkProps = (url?: string | null): TExternalLinkProps => {
    if (!url || typeof url !== 'string') return {};
    if (isPdfUrl(url)) return secureNewTabProps;

    try {
        const parsedUrl = new URL(url, 'https://ouronyx.com');

        if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') return {};

        const hostname = parsedUrl.hostname.toLowerCase();
        if (hostname === 'ouronyx.com' || hostname.endsWith('.ouronyx.com')) return {};

        return secureNewTabProps;
    } catch {
        return {};
    }
};
